<template>
  <div class="permission">
    <div class="text-2xl font-bold mb-6">Permission</div>
    <div class="border shadow-lg rounded-md bg-white">
      <div class="p-6 flex justify-between">
        <div class="flex items-center gap-4">
          <div class="w-60">
            <TextField type="text" v-model="searchTerm" :action="doSearch" placeholder="Masukan kata kunci" />
          </div>
          <div class="">
            <Button buttonText="Cari" @action="doSearch()" />
          </div>
        </div>
      </div>
      <TableComponent>
        <template v-slot:header>
          <td class="w-16 text-center">No.</td>
          <td class="w-96">id</td>
          <td class="w-96">Description</td>
        </template>
        <template v-slot:body>
          <template v-if="filteredData && filteredData.length > 0">
            <tr v-for="(item, index) in filteredData" :key="item.code">
              <td class="w-16 text-center">{{ (currentPage - 1) * perPage + (index + 1) }}</td>
              <td class="w-96">{{ item.id }}</td>
              <td class="w-96">{{ item.description }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5" class="text-center">
                <div class="py-6">Tidak ada data yang tersedia.</div>
              </td>
            </tr>
          </template>
        </template>
      </TableComponent>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
  },
  data: () => ({
    searchTerm: '',
    page: 1,
    totalPages: 10,
    total: 100,
    perPage: 10,
    currentPage: 1,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('role', ['permissionList']),
    filteredData() {
      let temp = this.permissionList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  methods: {
    ...mapActions('role', ['getPermissionList']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getPermission(searchTerm = '') {
      this.getPermissionList({
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          search_keyword: searchTerm
        }
      })
        .then(res => {
          this.total = res.data.meta.total_item
          this.totalPages = res.data.meta.total_page
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    doSearch() {
      this.getPermission(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/role/permission', query: { page: page } })
      this.page = page
      this.currentPage = page
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/role/permission', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getPermission()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getPermission()
      } else {
        this.$router.push({ path: '/role/permission', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
